import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import { CheckCircle2, PlusCircle, BarChart2 } from 'lucide-react';
import { Today } from './pages/Today';
import { AddHabit } from './pages/AddHabit';
import { WeeklyProgress } from './pages/WeeklyProgress';
export function App() {
  return <Router data-id="element-0">
      <div className="min-h-screen bg-[#FAFAF7] font-['Outfit']" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Today data-id="element-4" />} data-id="element-3" />
          <Route path="/add" element={<AddHabit data-id="element-6" />} data-id="element-5" />
          <Route path="/progress" element={<WeeklyProgress data-id="element-8" />} data-id="element-7" />
        </Routes>

        {/* Bottom Navigation */}
        <nav className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-md border-t border-gray-100 pb-safe" data-id="element-9">
          <div className="max-w-md mx-auto px-6 h-16 flex items-center justify-between" data-id="element-10">
            <NavLink to="/" className={({
            isActive
          }) => `flex flex-col items-center space-y-1 w-16 ${isActive ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-11">
              <CheckCircle2 size={24} strokeWidth={2.5} data-id="element-12" />
              <span className="text-[10px] font-medium" data-id="element-13">Today</span>
            </NavLink>

            <NavLink to="/add" className={({
            isActive
          }) => `flex flex-col items-center space-y-1 w-16 ${isActive ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-14">
              <PlusCircle size={24} strokeWidth={2.5} data-id="element-15" />
              <span className="text-[10px] font-medium" data-id="element-16">Add</span>
            </NavLink>

            <NavLink to="/progress" className={({
            isActive
          }) => `flex flex-col items-center space-y-1 w-16 ${isActive ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-17">
              <BarChart2 size={24} strokeWidth={2.5} data-id="element-18" />
              <span className="text-[10px] font-medium" data-id="element-19">Progress</span>
            </NavLink>
          </div>
        </nav>
      </div>
    </Router>;
}